import React from 'react';

type BadgeTipo = 'default' | 'success' | 'error' | 'warning' | 'info' | 'primary';

interface BadgeProps {
  children: React.ReactNode;
  tipo?: BadgeTipo;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, tipo = 'default', className = '' }) => {
  const getBadgeClasses = (currentTipo: BadgeTipo): string => {
    switch (currentTipo) {
      case 'success':
        return 'bg-success text-background';
      case 'error':
        return 'bg-danger text-text';
      case 'warning':
        return 'bg-warning text-background';
      case 'primary':
        return 'bg-gradient-to-r from-[#c5a663] via-[#f2dd82] to-[#c5a663] text-background';
      case 'info':
        return 'bg-gradient-to-r from-[#c5a663] via-[#f2dd82] to-[#c5a663] text-background';
      case 'default':
      default:
        return 'bg-red-500 text-text';
    }
  };

  const baseClasses = 'inline-flex items-center px-3 py-1 rounded-lg text-sm font-semibold transition-all duration-200 ease-in-out shadow-sm whitespace-nowrap';
  const typeClasses = getBadgeClasses(tipo);

  return (
    <span className={`${baseClasses} ${typeClasses} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;